import { Slider, TextField, Typography } from "@mui/material";
import { useState } from "react";

import "./SliderField.css";

interface SliderFieldProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
}

export function SliderField({ label, value, min, max, step, onChange }: SliderFieldProps) {
  const [typedValue, setTypedValue] = useState<string | null>(null);

  const commitTypedValue = () => {
    const parsed = Number(typedValue);
    if (typedValue?.trim() && Number.isFinite(parsed)) onChange(Math.min(max, Math.max(min, parsed)));
    setTypedValue(null);
  };

  return (
    <div>
      <Typography variant="body2" gutterBottom>
        {label}
      </Typography>
      <div className="slider-field">
        <Slider
          size="small"
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={(_, newValue) => onChange(newValue as number)}
          aria-label={label}
        />
        <TextField
          size="small"
          className="slider-field-input"
          value={typedValue ?? String(Number(value.toFixed(3)))}
          onChange={(event) => setTypedValue(event.target.value)}
          onBlur={commitTypedValue}
          onKeyDown={(event) => event.key === "Enter" && commitTypedValue()}
          slotProps={{ htmlInput: { inputMode: "decimal", "aria-label": label } }}
        />
      </div>
    </div>
  );
}
